import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'

// 计算当前这块dom是否跨越了a4大小，以此分割
const isSplit = (nodes, index, pageHeight) => {
    return !!(
        nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight &&
        nodes[index + 1] &&
        nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight
    )
}

// 页面导出为pdf格式
const downReport = async (PDFView) => {
    // 获取分割dom，此处为class类名为pdfItem的dom
    let lableListID = document.getElementsByClassName('pdfItem')

    let pageHeight = (PDFView.scrollWidth / 841.89) * 595.28 // 横版PDF
    // 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把它挤下去，进行分割
    for (let i = 0; i < lableListID.length; i++) {
        let multiple = Math.ceil(
            (lableListID[i].offsetTop + lableListID[i].offsetHeight) /
            pageHeight
        )
        if (isSplit(lableListID, i, multiple * pageHeight)) {
            let divParent = lableListID[i].parentNode // 获取该div的父节点
            let newNode = document.createElement('div')
            newNode.className = 'emptyDiv'
            newNode.style.background = '#ffffff'
            let _H =
                multiple * pageHeight -
                (lableListID[i].offsetTop + lableListID[i].offsetHeight)
            newNode.style.height = _H + 30 + 'px'
            newNode.style.width = '100%'
            let next = lableListID[i].nextSibling // 获取div的下一个兄弟节点
            if (next) {
                divParent.insertBefore(newNode, next) // 插入新节点
            } else {
                divParent.appendChild(newNode) // 添加到最后
            }
        }
    }
}

const htmlToPdf = {
    async getPdf(title, dom, _this) {
        let top = document.querySelector(dom)
        if (top != null) {
            top.scrollIntoView()
            top = null
        }

        // 截断的情景暂不处理，如果要处理把downReport函数打开即可
        // await downReport(document.querySelector(dom));

        await html2Canvas(document.querySelector(dom), {
            y: 50,
            allowTaint: false,
            taintTest: false,
            logging: false,
            useCORS: true,
            dpi: window.devicePixelRatio * 2, //将分辨率提高到特定的DPI 提高对应倍数
            scale: 2,//按比例增加分辨率
            onclone: (document) => {
                // 确保图片加载完成
                const images = document.querySelectorAll('img');
                images.forEach(img => {
                    if (img.complete) return; // 如果图片已加载完成
                    img.onload = () => {
                        console.log('Image loaded');
                    };
                });
            }
        }).then(canvas => {
            let pdf = new jsPDF('p', 'mm', 'a4');    //A4纸，纵向
            let ctx = canvas.getContext('2d'),
                a4w = 110, a4h = 277,    //A4大小，210mm x 297mm，左右保留50mm，上下10mm的边距，显示区域110*277
                // a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
                imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
                renderedHeight = 0;

            while (renderedHeight < canvas.height) {
                let page = document.createElement("canvas");
                page.width = canvas.width;
                page.height = Math.min(imgHeight, canvas.height - renderedHeight);

                // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
                page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
                pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 50, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    // 添加图像到页面

                renderedHeight += imgHeight;
                if (renderedHeight < canvas.height) {
                    pdf.addPage(); // 如果后面还有内容，添加一个空页
                }
            }

            // 将PDF转化为base64字符串，传给后台
            let data = pdf.output('dataurlstring');
            _this.pdfFile = data;

            // 移除页面中生成的空白占位结点
            // downReport函数打开了下面的for循环也跟着打开
            // let emptyDiv = document.getElementsByClassName('emptyDiv')
            // for (let i = 0; i < emptyDiv.length; i++) {
            //     emptyDiv[i].remove()
            //     i = i - 1
            // }
        }).catch(error => {
            console.error("Error generating PDF:", error);
        });
    },

    base64toFile(dataurl, filename = 'file') {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {
            type: mime
        })
    },
};

export default htmlToPdf;
